<div [formGroup]="boatFormGroup"
     fxLayout="row wrap">

    <div fxFlex="100">

        <div fxLayout="row" fxLayoutAlign="space-between center">
            <ng-container *ngIf="!slimmedView">
                <h2 [innerHTML]="headline"></h2>
            </ng-container>
        </div>

        <ng-container *ngIf="loadingBoats; else formContent">
            <div style="display: flex; justify-content: center; align-items: center;">
                <mat-spinner [diameter]="40"></mat-spinner>
            </div>
        </ng-container>

        <ng-template #formContent>

            <ng-template #boatAutocompleteOption let-boat="boat">
                <bcm-boat-link [disableLink]="true" [boat]="boat"></bcm-boat-link>
                <ng-container *ngIf="showBoatOptionDimensions(boat)">
                    <br>
                    <small class="boat-autocomplete-dimensions">
                        <booking-v2-dimensions
                                [length]="boatOptionLength(boat)"
                                [width]="boat.width"
                                [depth]="boat.depth"></booking-v2-dimensions>
                    </small>
                </ng-container>
                <ng-container *ngIf="(boat.owner || boat.ownerCompany)?.id; else noOwner">
                    <br>
                    <small>
                        <bcm-boat-owner-link [disableLink]="true" [boat]="boat"></bcm-boat-owner-link>
                    </small>
                </ng-container>
                <ng-template #noOwner>
                    <br>
                    <small class="color-warn">{{ 'workflows.formWidgets.boat.noOwner' | translate }}</small>
                </ng-template>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field fxFlex [appearance]="appearance" floatLabel="always">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label>{{ 'workflows.formWidgets.boat.searchLabel' | translate }}</mat-label>
                    <input matInput
                           [readonly]="readonly"
                           type="text"
                           formControlName="boat"
                           (keydown.enter)="$event.preventDefault()"
                           [matAutocomplete]="boatSelector">
                    <mat-hint>{{ 'workflows.formWidgets.boat.up2boatIdHint' | translate:{}:'Name oder Up2Boat-ID' }}</mat-hint>

                    <mat-autocomplete
                            #boatSelector="matAutocomplete"
                            [displayWith]="displayBoatWith">

                        <ng-container *ngIf="isSearching">
                            <mat-option disabled>
                                <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
                                {{ 'workflows.formWidgets.boat.searching' | translate }}
                            </mat-option>
                        </ng-container>

                        <ng-container *ngIf="!isSearching">
                            <ng-container *ngIf="displayBoatOwnerName?.length > 0 || boatOwnerName?.length > 0">
                                <ng-container *ngIf="filteredTopList$ | async as topList">
                                    <ng-container *ngIf="topList?.length">
                                        <mat-optgroup
                                                [label]="('workflows.formWidgets.boat.boatsFromOwner' | translate : {boatOwnerName: (boatOwnerName || displayBoatOwnerName)})">
                                            <ng-container *ngFor="let boat of topList">
                                                <mat-option [value]="boat">
                                                    <ng-container *ngTemplateOutlet="boatAutocompleteOption; context: { boat: boat }"></ng-container>
                                                </mat-option>
                                            </ng-container>
                                        </mat-optgroup>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="filteredBottomList$ | async as bottomList">
                                <ng-container *ngIf="bottomList?.length">
                                    <mat-optgroup
                                            [label]="(displayBoatOwnerName?.length > 0 || boatOwnerName?.length > 0) ?('workflows.formWidgets.boat.moreBoats' | translate) :('workflows.formWidgets.boat.allBoats' | translate)">
                                        <ng-container *ngFor="let boat of bottomList">
                                            <mat-option [value]="boat">
                                                <ng-container *ngTemplateOutlet="boatAutocompleteOption; context: { boat: boat }"></ng-container>
                                            </mat-option>
                                        </ng-container>
                                    </mat-optgroup>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="!(filteredTopList$ | async)?.length && !(filteredBottomList$ | async)?.length">
                                <mat-option disabled>
                                    {{ 'workflows.formWidgets.boat.noBoatsFound' | translate }}
                                </mat-option>
                            </ng-container>
                        </ng-container>

                    </mat-autocomplete>

                    <div matSuffix>
                        <ng-container *ngIf="editable && boat?.id && !readonly">
                            <button
                                    mat-icon-button
                                    type="button"
                                    color="primary"
                                    [matTooltip]="'workflows.formWidgets.boat.editTooltip' | translate"
                                    (click)="openEditDialog($event)">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="!boat?.id && canCreate && !readonly">
                            <button
                                    mat-icon-button
                                    type="button"
                                    color="primary"
                                    [matTooltip]="'workflows.formWidgets.boat.createTooltip' | translate"
                                    (click)="openEditDialog($event)">
                                <mat-icon>add_circle_outline</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="!readonly">
                            <button
                                    mat-icon-button
                                    type="button"
                                    color="warn"
                                    [matTooltip]="'workflows.formWidgets.boat.deleteTooltip' | translate"
                                    [disabled]="!boat?.id || boatFormGroup.disabled"
                                    (click)="onClickRemoveBoat()">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </ng-container>
                    </div>
                    <mat-error
                            [hidden]="slimmedView">{{ boatFormGroup.get('boat').errors | firstErrorMessage }}
                    </mat-error>
                </mat-form-field>

            </div>

        </ng-template>
    </div>

    <ng-container *ngIf="boat?.id && showMetaData">
        <div fxFlex="100">
            <table class="simple sm">
                <tbody>
                <tr>
                    <td>Länge&nbsp;(m):</td>
                    <td fxLayoutAlign="end center">{{ boat.length || 'Keine Angabe' }}</td>
                </tr>
                <tr>
                    <td>Breite&nbsp;(m):</td>
                    <td fxLayoutAlign="end center">{{ boat.width || 'Keine Angabe' }}</td>
                </tr>
                <tr>
                    <td>Tiefgang&nbsp;(m):</td>
                    <td fxLayoutAlign="end center">{{ boat.depth || 'Keine Angabe' }}</td>
                </tr>
                <tr>
                    <td>Länge über Alles&nbsp;(m):</td>
                    <td fxLayoutAlign="end center">{{ boat.lengthOverall || 'Keine Angabe' }}</td>
                </tr>
                <tr>
                    <td>Fläche (m²):</td>
                    <td fxLayoutAlign="end center">{{ (boat.sqm | number: '1.2-2') || 'Keine Angabe' }}</td>
                </tr>
                <ng-container *ngIf="givenBerth?.isBuoy">
                    <tr>
                        <td>Gewicht (kg):</td>
                        <td fxLayoutAlign="end center">{{ boat.weight || 'Keine Angabe' }}</td>
                    </tr>
                </ng-container>
                </tbody>
            </table>
        </div>
    </ng-container>

</div>
